import script from "./FVTPL.vue?vue&type=script&setup=true&lang=js"
export * from "./FVTPL.vue?vue&type=script&setup=true&lang=js"

import "./FVTPL.vue?vue&type=style&index=0&id=0adf118a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0adf118a"]])

export default __exports__